export const MANUFACTURER_PART_NUMBER = 'Manufacturer Part Number';
export const PART_NUMBER = 'number';
export const DESCRIPTION = 'description';

export const pillList = [
  {
    id: 'number',
    name: 'Manufacturer Part Number',
  },
  {
    id: 'manufacturer',
    name: 'Manufacturer',
  },
  {
    id: 'uom',
    name: 'Base Uom',
  },
  {
    id: 'description',
    name: 'Description',
  },
  {
    id: 'vendorNumber',
    name: 'Company Part Number',
  },
  {
    id: 'companyManufacturerName',
    name: 'Company Manufacturer Name',
  },
  {
    id: 'companyManufacturerId',
    name: 'Company Manufacturer ID',
  },
  {
    id: 'packageType',
    name: 'Item Type',
  },
  {
    id: 'purchaseCostUom',
    name: 'Purchase UOM',
  },
  {
    id: 'packageUom',
    name: 'Package UOM',
  },
  {
    id: 'salesUom',
    name: 'Sales UOM',
  },
  {
    id: 'externalUom',
    name: 'External/ERP UOM',
  },
  {
    id: 'orderIncrement',
    name: 'Sales Order Increment',
  },
  {
    id: 'manufacturerOrderIncrement',
    name: 'Vendor Order Increment',
  },
  {
    id: 'pkgUnits',
    name: 'Package Quantity',
  },
  {
    id: 'manufacturerMinimumQuantity',
    name: 'Vendor Minimum Order Quantity',
  },
  {
    id: 'minimumQuantity',
    name: 'Sales Minimum Order Quantity',
  },
  {
    id: 'quotePriceDecimals',
    name: 'Quote Price Decimals',
  },
  {
    id: 'bomPriceDecimals',
    name: 'BoM price decimals',
  },
  {
    id: 'listPrice',
    name: 'List Price [per purchase UOM]',
  },
  {
    id: 'floorPrice',
    name: 'Floor Price [per purchase UOM]',
  },
  {
    id: 'pricingFactor',
    name: 'Pricing Factor',
  },
  {
    id: 'partBaseCode',
    name: 'Part Base Code',
  },
  {
    id: 'className',
    name: 'Class',
  },
  {
    id: 'taaStatus',
    name: 'TAA Status',
  },
  {
    id: 'mfgPartStatus',
    name: 'Manufacturer Part Status',
  },
  {
    id: 'companyPartStatus',
    name: 'Company Part Status',
  },
  {
    id: 'replacementPart',
    name: 'Replacement Part',
  },
  {
    id: 'costStartDate',
    name: 'Cost Start Date',
  },
  {
    id: 'costEndDate',
    name: 'Cost End Date',
  },
  {
    id: 'costNote',
    name: 'Cost Note',
  },
  {
    id: 'cost1',
    name: 'Cost 1 [per purchase UOM]',
  },
];

export const hiddenCostPillList = [
  {
    id: 'cost2',
    name: 'Cost 2 [per purchase UOM]',
  },
  {
    id: 'quantity2',
    name: 'Qty 2 [purchase UOM]',
  },
  {
    id: 'cost3',
    name: 'Cost 3 [per purchase UOM]',
  },
  {
    id: 'quantity3',
    name: 'Qty 3 [purchase UOM]',
  },
  {
    id: 'cost4',
    name: 'Cost 4 [per purchase UOM]',
  },
  {
    id: 'quantity4',
    name: 'Qty 4 [purchase UOM]',
  },
  {
    id: 'cost5',
    name: 'Cost 5 [per purchase UOM]',
  },
  {
    id: 'quantity5',
    name: 'Qty 5 [purchase UOM]',
  },
];

export const hiddenPricingPillList = [
  {
    id: 'pricingGroup1',
    name: 'Pricing Group 1',
  },
  {
    id: 'pricingGroupDescription1',
    name: 'Pricing Group Description 1',
  },
  {
    id: 'pricingGroup2',
    name: 'Pricing Group 2',
  },
  {
    id: 'pricingGroupDescription2',
    name: 'Pricing Group Description 2',
  },
  {
    id: 'pricingGroup3',
    name: 'Pricing Group 3',
  },
  {
    id: 'pricingGroupDescription3',
    name: 'Pricing Group Description 3',
  },
  {
    id: 'pricingGroup4',
    name: 'Pricing Group 4',
  },
  {
    id: 'pricingGroupDescription4',
    name: 'Pricing Group Description 4',
  },
  {
    id: 'pricingGroup5',
    name: 'Pricing Group 5',
  },
  {
    id: 'pricingGroupDescription5',
    name: 'Pricing Group Description 5',
  },
];

export const vendorCostPills = [
  {
    id: 'number',
    name: 'Manufacturer Part Number',
  },
  {
    id: 'manufacturer',
    name: 'Manufacturer',
  },
  {
    id: 'description',
    name: 'Description',
  },
  {
    id: 'purchaseCostUom',
    name: 'Purchase UOM',
  },
  {
    id: 'listPrice',
    name: 'List Price [per purchase UOM]',
  },
  {
    id: 'floorPrice',
    name: 'Floor Price [per purchase UOM]',
  },
  {
    id: 'costStartDate',
    name: 'Cost Start Date',
  },
  {
    id: 'costEndDate',
    name: 'Cost End Date',
  },
  {
    id: 'cost1',
    name: 'Cost 1 [per purchase UOM]',
  },
  {
    id: 'pricingFactor',
    name: 'Pricing Factor',
  },
];

export const partAttributesPills = [
  {
    id: 'number',
    name: 'Manufacturer Part Number',
  },
  {
    id: 'manufacturer',
    name: 'Manufacturer',
  },
  {
    id: 'uom',
    name: 'Base Uom',
  },
  {
    id: 'description',
    name: 'Description',
  },
  {
    id: 'vendorNumber',
    name: 'Company Part Number',
  },
  {
    id: 'companyManufacturerName',
    name: 'Company Manufacturer Name',
  },
  {
    id: 'companyManufacturerId',
    name: 'Company Manufacturer ID',
  },
  {
    id: 'packageType',
    name: 'Item Type',
  },
  {
    id: 'packageUom',
    name: 'Package UOM',
  },
  {
    id: 'salesUom',
    name: 'Sales UOM',
  },
  {
    id: 'externalUom',
    name: 'External/ERP UOM',
  },
  {
    id: 'orderIncrement',
    name: 'Sales Order Increment',
  },
  {
    id: 'manufacturerOrderIncrement',
    name: 'Vendor Order Increment',
  },
  {
    id: 'pkgUnits',
    name: 'Package Quantity',
  },
  {
    id: 'manufacturerMinimumQuantity',
    name: 'Vendor Minimum Order Quantity',
  },
  {
    id: 'minimumQuantity',
    name: 'Sales Minimum Order Quantity',
  },
  {
    id: 'quotePriceDecimals',
    name: 'Quote Price Decimals',
  },
  {
    id: 'bomPriceDecimals',
    name: 'BoM price decimals',
  },
  {
    id: 'partBaseCode',
    name: 'Part Base Code',
  },
  {
    id: 'className',
    name: 'Class',
  },
  {
    id: 'taaStatus',
    name: 'TAA Status',
  },
  {
    id: 'mfgPartStatus',
    name: 'Manufacturer Part Status',
  },
  {
    id: 'companyPartStatus',
    name: 'Company Part Status',
  },
  {
    id: 'replacementPart',
    name: 'Replacement Part',
  },
  {
    id: 'costNote',
    name: 'Cost Note',
  },
];
